/**
 * reducer
 */

// import { combineReducers } from 'redux'
import { type } from '../action';
const ebikeData = (state, action) => {
    switch (action.type) {
        case type.INFOTYPE:
            return {
                ...state,
                headName:action.headName
            };

        case type.artType:
            return {
                ...state,
                artName:action.artName
            };
        case type.loginType:
            return {
                ...state,
                isShow:action.isShow,
                isReg:action.isReg
            };
        case type.ArtIdType:
            return {
                ...state,
                artId:action.artId
            };
        case type.showMsgType:
            return {
                ...state,
                showMsg:action.showMsg
            };
        case type.isLoginType:
            return {
                ...state,
                isLogin:action.isLogin
            };
        default:
            return {...state};
    }
};

export default ebikeData;